<div class="tagsBox p-0050">
  <span class="field-label mb-0050 caps--light">
    <i class="fal fa-plus"></i>
    Include Fields
  </span>

  <span class="mb-0025 mt-0025 d-block color--gray--004 txt-14">
    Include when <strong>having any</strong> responses for:
  </span>
  <app-fields-advanced-rule-input *ngIf="includeExcludeRules.includeRule"
                                  [showInlineOperator]="false"
                                  [(ngModel)]="includeExcludeRules.includeRule.value"
                                  [campaignId]="campaignId"
                                  [targetType]="targetType"></app-fields-advanced-rule-input>
</div>

<div class="tagsBox p-0050 mt-0050">
  <span class="field-label mb-0050 caps--light">
    <i class="fal fa-minus"></i>
    Exclude Fields
  </span>

  <span class="mb-0025  mt-0025 d-block color--gray--004 txt-14">
    Exclude when <strong>having any</strong> responses for:
  </span>
  <app-fields-advanced-rule-input *ngIf="includeExcludeRules.excludeRule"
                                  [showInlineOperator]="false"
                                  [(ngModel)]="includeExcludeRules.excludeRule.value"
                                  [campaignId]="campaignId"
                                  [targetType]="targetType"></app-fields-advanced-rule-input>
</div>
